import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { ICreateFarmerPayload, IFarmer } from "../types/farmers";

const API = process.env.REACT_APP_API;

const useCreateFarmer = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data }: { data: ICreateFarmerPayload }) => {
      return fetch(`${API}/api/semeadora/farmers`, {
        method: "POST",
        body: data,
      }) as Promise<IFarmer>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["farmers"] });
    },
    onError: (error) => {
      console.error("Erro ao criar agricultora", error);
    },
  });
};

export default useCreateFarmer;
